import httpBase from "../utils/http.utils";
import { EVALUATE } from "../constants/url";

const sanitizeFeedbackPayload = (payload = {}) => {
  const sanitizedPayload = { ...payload };
  const createdAt = sanitizedPayload?.created_at;

  if (createdAt === null || createdAt === undefined || createdAt === "") {
    delete sanitizedPayload.created_at;
    return sanitizedPayload;
  }

  const parsedDate = Date.parse(createdAt);
  if (Number.isNaN(parsedDate)) {
    delete sanitizedPayload.created_at;
    return sanitizedPayload;
  }

  sanitizedPayload.created_at = new Date(parsedDate).toISOString();
  return sanitizedPayload;
};

export const handleFeedbackApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const sanitizedData = sanitizeFeedbackPayload(data);
      const response = await httpBase().post(EVALUATE, sanitizedData);
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const handleFeedbackDeleteApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().delete(EVALUATE, { data: data });
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};
